import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-core-page-dashboard',
    templateUrl: './page-dashboard.component.html',
    styleUrls: ['./page-dashboard.component.scss'],
    standalone: false
})
export class PageDashboardComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
